// ─────────────────────────────────────────────────────────────────────────────
// CrewZ BLE UUID Configuration (Web port)
// Mirrors src/config/ble-uuids.ts in jas0nday/Crew-Z (React Native).
// ─────────────────────────────────────────────────────────────────────────────
// Single source of truth for BLE UUIDs. When firmware confirms real UUIDs,
// update ONLY this file.
// Format: standard 128-bit UUID strings.
// ─────────────────────────────────────────────────────────────────────────────

export const CREWZ_UUIDS = {
  // ── Service UUIDs ──────────────────────────────────────────────────────────
  ROWING_METRICS_SERVICE: '00000001-0000-1000-8000-00805f9b34fb',
  DEVICE_STATUS_SERVICE:  '00000002-0000-1000-8000-00805f9b34fb',
  CONFIGURATION_SERVICE:  '00000003-0000-1000-8000-00805f9b34fb',
  COACH_METRICS_SERVICE:  '00000004-0000-1000-8000-00805f9b34fb',

  // ── Rowing Metrics Characteristics (notify @ 5Hz) ──────────────────────────
  CHAR_SPEED:             '00000101-0000-1000-8000-00805f9b34fb', // m/s × 100 (uint16)
  CHAR_SPLIT:             '00000102-0000-1000-8000-00805f9b34fb', // s/500m (uint16)
  CHAR_STROKE_RATE:       '00000103-0000-1000-8000-00805f9b34fb', // SPM (uint8)
  CHAR_STROKE_COUNT:      '00000104-0000-1000-8000-00805f9b34fb', // cumulative (uint32)
  CHAR_DISTANCE:          '00000105-0000-1000-8000-00805f9b34fb', // metres (uint32)
  CHAR_ELAPSED_TIME:      '00000106-0000-1000-8000-00805f9b34fb', // seconds (uint32)
  CHAR_HEART_RATE:        '00000107-0000-1000-8000-00805f9b34fb', // BPM (uint8) – 0 = no belt

  // ── Device Status Characteristics (notify @ 0.2Hz) ─────────────────────────
  CHAR_BATTERY:           '00000201-0000-1000-8000-00805f9b34fb', // 0-100 (uint8)
  CHAR_GPS_FIX:           '00000202-0000-1000-8000-00805f9b34fb', // 0=none,1=2D,2=3D
  CHAR_BLE_CONN_COUNT:    '00000203-0000-1000-8000-00805f9b34fb', // Coach only
  CHAR_VARIANT_ID:        '00000204-0000-1000-8000-00805f9b34fb', // 0=Speed,1=Cox,2=Coach
  CHAR_FIRMWARE_VERSION:  '00000205-0000-1000-8000-00805f9b34fb', // UTF-8 string

  // ── Configuration Characteristics (read/write) ─────────────────────────────
  CHAR_CHARGE_MIN:        '00000301-0000-1000-8000-00805f9b34fb',
  CHAR_CHARGE_MAX:        '00000302-0000-1000-8000-00805f9b34fb',
  CHAR_DISPLAY_UNITS:     '00000303-0000-1000-8000-00805f9b34fb', // 0=metric,1=imperial
  CHAR_AMP_GAIN:          '00000304-0000-1000-8000-00805f9b34fb', // Cox only
  CHAR_COACH_SCAN:        '00000305-0000-1000-8000-00805f9b34fb', // Coach only

  // ── Coach Metrics Characteristics (8 crew slots) ───────────────────────────
  CHAR_CREW_SLOT_0:       '00000401-0000-1000-8000-00805f9b34fb',
  CHAR_CREW_SLOT_1:       '00000402-0000-1000-8000-00805f9b34fb',
  CHAR_CREW_SLOT_2:       '00000403-0000-1000-8000-00805f9b34fb',
  CHAR_CREW_SLOT_3:       '00000404-0000-1000-8000-00805f9b34fb',
  CHAR_CREW_SLOT_4:       '00000405-0000-1000-8000-00805f9b34fb',
  CHAR_CREW_SLOT_5:       '00000406-0000-1000-8000-00805f9b34fb',
  CHAR_CREW_SLOT_6:       '00000407-0000-1000-8000-00805f9b34fb',
  CHAR_CREW_SLOT_7:       '00000408-0000-1000-8000-00805f9b34fb',
};

// Device variant enum — matches CHAR_VARIANT_ID values from firmware
export const CrewZVariant = Object.freeze({
  Speed: 0,
  Cox:   1,
  Coach: 2,
});

// Web Bluetooth scan filter — devices advertising the Rowing Metrics service
export const CREWZ_SCAN_UUIDS = [CREWZ_UUIDS.ROWING_METRICS_SERVICE];

// Human-readable variant labels
export const VARIANT_LABELS = {
  [CrewZVariant.Speed]: 'Speed',
  [CrewZVariant.Cox]:   'Cox',
  [CrewZVariant.Coach]: 'Coach',
};
